import React from 'react';

// 04-enforce.md 4.1 -- extraído de SubPanelTratos.jsx (rama `isClienteNode` del tab
// "Parámetros"): foto de perfil + campos editables del cliente + documentos oficiales. Recibe
// los renderers (`renderAutoInput`/`renderUploadBtn`) como render-props del container -- mismo
// patrón que `SubPanelFormularioNegocio`, porque son closures sobre `formData`/`savedFields`/
// `availableVariables`.
const SubPanelClienteProfile = ({ formData, op, publicUuid, onFileUpload, renderAutoInput, renderUploadBtn }) => {
  const canEditAvatar = !publicUuid || formData.is_public;
  const skills = (formData.skills || '').split(',').map(s => s.trim()).filter(Boolean);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-5)', padding: 'var(--space-1) 0' }}>

      {/* 1. User Profile Section */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-5)',
        background: 'rgba(255, 255, 255, 0.02)',
        border: '1px solid rgba(255, 255, 255, 0.06)',
        borderRadius: 'var(--radius-xl)',
        padding: 'var(--space-5)',
        marginBottom: 'var(--space-3)'
      }}>
        {/* Clickable circular profile picture */}
        <div
          onClick={() => { if (canEditAvatar) document.getElementById('file-cliente_img').click(); }}
          style={{
            width: '84px',
            height: '84px',
            borderRadius: '50%',
            overflow: 'hidden',
            border: '3px solid rgba(59, 130, 246, 0.4)',
            background: 'linear-gradient(135deg, #3b82f6 0%, #1e3a8a 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            cursor: canEditAvatar ? 'pointer' : 'default',
            position: 'relative'
          }}
        >
          {formData.cliente_img || op.cliente_img ? (
            <img src={formData.cliente_img || op.cliente_img} alt={formData.cliente_nick || op.cliente_nick} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            <span style={{ fontSize: '32px', color: '#fff', fontWeight: 'bold' }}>
              {(formData.cliente_nick || op.cliente_nick || '?')[0].toUpperCase()}
            </span>
          )}
          <input type="file" id="file-cliente_img" style={{ display: 'none' }} onChange={e => onFileUpload(e, 'cliente_img')} />
        </div>

        {/* Nick / Name and Email */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-1)', flex: 1 }}>
          <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#fff' }}>
            {formData.cliente_nick || op.cliente_nick || 'Cliente sin nombre'}
          </div>
          <div style={{ fontSize: '13px', color: 'rgba(255, 255, 255, 0.5)' }}>
            {formData.correo || 'correo@ejemplo.com'}
          </div>
        </div>
      </div>

      {/* 2. Editable User Info Fields */}
      <div className="op-sub-panel-field">
        <label>Nombre / Nick</label>
        {renderAutoInput("cliente_nick", "text", { placeholder: "Nombre del cliente" }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>)}
      </div>

      <div className="op-sub-panel-field">
        <label>Correo Electrónico</label>
        {renderAutoInput("correo", "email", { placeholder: "correo@ejemplo.com" }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>)}
      </div>

      <div className="op-sub-panel-field">
        <label>Número de teléfono</label>
        {renderAutoInput("telefono", "tel", { placeholder: "+56 9 1234 5678" }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>)}
      </div>

      <div className="op-sub-panel-field">
        <label>Ubicación</label>
        {renderAutoInput("ubicacion", "text", { placeholder: "Ej. Ciudad de México, México" }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>)}
      </div>

      <div className="op-sub-panel-field">
        <label>Religión</label>
        {renderAutoInput("religion", "text", { placeholder: "Religión" }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v8M9 11h6"/></svg>)}
      </div>

      <div className="op-sub-panel-field">
        <label>Skills / Habilidades (separadas por comas)</label>
        {renderAutoInput("skills", "text", { placeholder: "React, Node, Sales, Management" }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>)}
        {skills.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-2)', marginTop: 'var(--space-3)' }}>
            {skills.map((skill, idx) => (
              <span key={idx} style={{ background: 'rgba(59, 130, 246, 0.15)', color: '#3b82f6', border: '1px solid rgba(59, 130, 246, 0.3)', padding: '2px var(--space-2)', borderRadius: 'var(--radius-md)', fontSize: '11px', fontWeight: 'bold' }}>
                {skill}
              </span>
            ))}
          </div>
        )}
      </div>

      {/* 3. Official Documents Section */}
      <div style={{ marginTop: 'var(--space-6)', borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: 'var(--space-5)' }}>
        <h3 style={{ fontSize: '14px', fontWeight: '600', color: '#fff', marginBottom: 'var(--space-4)', letterSpacing: '0.5px' }}>DOCUMENTOS OFICIALES</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
          {renderUploadBtn('Identificación Oficial Frente', 'id_front')}
          {renderUploadBtn('Identificación Oficial Reverso', 'id_back')}
          {renderUploadBtn('CURP', 'curp')}
          {renderUploadBtn('Comprobante de Domicilio', 'proof_address')}
          {renderUploadBtn('Acta de Nacimiento', 'birth_cert')}
        </div>
      </div>

    </div>
  );
};

export default SubPanelClienteProfile;
